import React, { useEffect, useMemo } from "react";
import { Field } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { createRequiredValidator } from "../../components/forms/validator";
import { Select } from "../../components/Inputs/Select/Select";
import { MultiSelect } from "../../components/Inputs/MultiSelect/MultiSelect";

import { entitySelector } from "./state/selectors";
import { getFiltersOptions } from "./state/actions";

export const SelectEntityByType = React.memo(({
    className,
    FieldsTypes,
    params,
    onSortOption,
    label,
    isRequired,
    errorMessage,
    isReloadAllTime,
    initialOptions = [],
    selectAll,
    onFieldChange,
    menuPlacement = "auto",
    addOptionToSelectOptions = null,
    ...restSelectEntityProps
}) => {
    const filters = useSelector(entitySelector);
    const filterData = filters[FieldsTypes] || {};
    const { options = [], isLoading } = filterData;
    const dispatch = useDispatch();

    if (addOptionToSelectOptions !== null) {
        let exists = false;
        for (const option of options) {
            if (option.value === addOptionToSelectOptions.value) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            options.push(addOptionToSelectOptions)
        }
    }

    /*eslint-disable */
    useEffect( () => {
        if( !Object.keys( filterData ).length || isReloadAllTime ) {
            dispatch( getFiltersOptions( { filterType: FieldsTypes, params } ) );
        }
    },[ FieldsTypes, params ] );
    /*eslint-disable */

    const validator = useMemo( () => (
        isRequired && createRequiredValidator()
    ), [ label, isRequired, errorMessage ] );

    const entityOptions = useMemo(
        () => {
        const mixedOptions = [...initialOptions, ...options];

        if(selectAll && options) {
            mixedOptions.push(selectAll);

            return onSortOption ? onSortOption(mixedOptions) : mixedOptions;
        }

        return onSortOption ? onSortOption(mixedOptions) : mixedOptions;
    },
        [ selectAll, options, onSortOption, initialOptions ]
    );

    return (
    <Field
        label={label}
        validate={validator}
        {...restSelectEntityProps}
    >
        { ({
            input,
            meta,
            ...restProps
        }) => {
            const errorMessage = ((meta.dirty || meta.touched || meta.submitFailed) && meta.error) ? meta.error : "";

            const onChange = (value) => {
                input.onChange(value);

                if(typeof onFieldChange === 'function') {
                    onFieldChange(value)
                }
            }

            if (restSelectEntityProps.mode && restSelectEntityProps.mode === "withFiltering") {
                return <MultiSelect
                    className={className}
                    {...input}
                    onChange={onChange}
                    isClearable
                    isSearchable
                    placeholder="Select"
                    menuPlacement={menuPlacement}
                    isLoading={isLoading}
                    options={entityOptions}
                    error={errorMessage}
                    {...restProps}
                />
            }

            return (
                <Select
                    className={className}
                    {...input}
                    onChange={onChange}
                    isClearable
                    isSearchable
                    placeholder="Select"
                    isLoading={isLoading}
                    options={entityOptions}
                    error={errorMessage}
                    {...restProps}
                />
            );
        } }
    </Field>
    );
});
